import React from "react";
import PropTypes from "prop-types";

import { collectionsTypes } from "core/props";

import Heading from "core/Heading";
import BodyText from "core/BodyText";
import GraphicContainer from "./GraphicContainer";
import { Link } from "react-router-dom";

import { MaterialUIGridContainer } from "core/MaterialUI";
import {
    CollectionsGridItem,
    CollectionBoxLink,
    CollectionContent,
    TextContainer,
    BoxHeadingContainer
} from "./styles";

const BoxStructure = ({ url, type, isPhoto, title, box, isLink }) => {
    return (
        <CollectionsGridItem item sm={12} md={4} lg={4}>
            <CollectionBoxLink
                {...(isLink ? { to: url } : { href: url })}
                type={type}
                isPhoto={isPhoto}
                as={isLink ? Link : "a"}
            >
                <CollectionContent>
                    <TextContainer>{title}</TextContainer>

                    {box}
                </CollectionContent>
            </CollectionBoxLink>
        </CollectionsGridItem>
    );
};

const CollectionBoxes = ({ collections, isLink = false }) => {
    return (
        <MaterialUIGridContainer
            mobileMaxPadding={0}
            // passing in 0 means that we are not using Material UI spacing for mobile; Material UI has trouble with numbers larger than 24 on mobile, so this is done via CSS for this breakpoint.
            tabletMaxPadding={4}
            // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            desktopMinPadding={9}
            // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of core/MaterialUI/ for this spacing array)
        >
            {collections.map((collection, idx) => {
                const {
                    title = collection.name,
                    url = collection.url,
                    imageSrcAndTitle = collection.icons.items.map(icon => {
                        return {
                            imageSrc: icon.thumbnails.thumbnail84,
                            title: icon.title
                        };
                    }),
                    type = "secondary",
                    backgroundSize = "auto 100%",
                    backgroundPosition,
                    usePlaceholder = true,
                    isPhoto = false
                } = collection;

                const subtitle = collection.subtitle
                    ? collection.subtitle
                    : collection.icons
                    ? collection.icons.totalCount + " icons"
                    : null;

                return (
                    <BoxStructure
                        key={idx}
                        url={url}
                        type={type}
                        isPhoto={isPhoto}
                        isLink={isLink}
                        title={
                            <>
                                <BoxHeadingContainer>
                                    <Heading
                                        type="h5"
                                        size="sm"
                                        alignment="left"
                                    >
                                        {title}
                                    </Heading>
                                </BoxHeadingContainer>
                                {subtitle && (
                                    <BodyText
                                        type="p"
                                        size="lg"
                                        alignment="left"
                                    >
                                        {subtitle}
                                    </BodyText>
                                )}
                            </>
                        }
                        box={
                            <GraphicContainer
                                imageSrcAndTitle={imageSrcAndTitle}
                                backgroundSize={backgroundSize}
                                backgroundPosition={backgroundPosition}
                                usePlaceholder={usePlaceholder}
                            />
                        }
                    />
                );
            })}
        </MaterialUIGridContainer>
    );
};

CollectionBoxes.propTypes = {
    collections: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            url: PropTypes.string,
            imageSrcAndTitle: PropTypes.oneOfType([
                PropTypes.array,
                PropTypes.object
            ]),
            subtitle: PropTypes.string,
            type: PropTypes.oneOf(collectionsTypes),
            backgroundSize: PropTypes.string,
            backgroundPosition: PropTypes.string,
            usePlaceholder: PropTypes.bool,
            isPhoto: PropTypes.bool,
            showSkeleton: PropTypes.bool
        })
    ),
    isLink: PropTypes.bool
};

export default CollectionBoxes;
